import { render, staticRenderFns } from "./StructTable.vue?vue&type=template&id=a9c97184"
import script from "./StructTable.vue?vue&type=script&lang=js"
export * from "./StructTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports